import React, { useEffect } from 'react'
import logo from "../../assets/images/freelancing.png"
import NewsLetter from '../NewsLetter/NewsLetter';


const About = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div>
      {/* <section className="bg-white dark:bg-gray-900 m-2">
        <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
          <div className="mr-auto place-self-center lg:col-span-7">
            <h1 className="max-w-2xl mb-4 text-4xl font-semibold tracking-tight leading-none text-blue-900 dark:text-white">ABOUT US</h1>
            <p className="max-w-2xl mb-6 font-semibold text-black lg:mb-8 md:text-2xl lg:text-2xl
             dark:text-gray-400"> Started as a Free lancer in the year of 2020 and started <br />
              Making Minds Technologies  in the year 2023.
              The main vision to Develop Standard Modern Websites  At Low Cost.</p>

          </div>
          <div className=" lg:mt-0 lg:col-span-5 lg:flex rounded">
            <img src={logo} alt="compay" className='rounded-lg ' />
          </div>
        </div>
      </section> */}


      <div className="bg-mgray py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl mt-10 font-semibold font-mfont text-mcolor sm:text-4xl">
              About us
            </h2>
            <p className="mt-10 mb-10 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-xl text-lg lg:text-2xl dark:text-gray-400">
              At Making Minds Technologies , we are not just developers; we are architects of digital experiences,
              pioneers in the realm of web development, and your partners in turning ideas into reality.
              Established with a passion for innovation and a commitment to delivering unparalleled digital
              solutions, we stand at the forefront of the ever-evolving landscape of technology. </p>
          </div>
        </div>
      </div>

      <div className="bg-mblue lg:py-20 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="lg:text-5xl mt-10 font-semibold font-mfont text-mcolor text-4xl">
              Making Minds Technologies wan't build in a day.
            </h2>
            <h2 className="lg:text-5xl mt-5 font-semibold font-mfont text-mcolor text-4xl">
              This is our story.
            </h2>
            <p className="mt-6 mb-10 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-xl text-lg lg:text-2xl dark:text-gray-400">
              Born out of a shared vision to revolutionize the digital space, Making Minds Technologies was
              founded by a group of seasoned professionals with collective experience in the industry.
              From the outset, we set out to create a company that embodies creativity, technical
              expertise, and client-centric values. A ground-breaking concept was born:&nbsp;
              <span className='text-bold bg-mpink'>"Innovation in
                Software Solutions"</span>&nbsp;via the involvement of young people, to create an innovation in the
              field of IT. This idea evolved to become the world-class technology company we're known
              as today.</p>
          </div>
        </div>
      </div>

      {/* <section className="overflow-hidden pt-20 lg:m-10 m-5  lg:pt-[120px]  bg-white dark:bg-dark">
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center ">
            <div className="w-full px-4 ">
              <div className="mt-1">
                <span className="block mb-4 font-mfont text-md font-semibold text-primary">
                  About Us<svg width="88" height="12" viewBox="0 0 200 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6171_16082)">
                      <path d="M98.474 1.84204C121.094 1.50816 143.714 1.06994 166.344 0.882134C175.926 0.798664 185.506 1.16385 195.077 1.54989C196.469 1.60206 198.77 2.73934 198.952 3.69925C199.22 5.05564 198.331 7.14239 197.207 8.14403C194.209 10.8151 190.346 11.5246 186.331 11.5454C171.633 11.6393 156.935 11.8897 142.237 11.8689C104.812 11.8376 67.3865 11.7019 29.9615 11.5767C22.7142 11.5559 15.4775 11.368 8.23016 11.295C4.63324 11.2637 1.58232 9.93865 -0.355309 7.0798C-1.12608 5.95295 -1.1796 3.87662 -0.65505 2.58283C-0.301783 1.70639 1.62513 0.944734 2.85621 0.944734C34.7253 0.861264 66.5943 0.87169 98.474 0.87169C98.474 1.1847 98.474 1.50815 98.474 1.82117V1.84204Z" fill="#00CEB3" />
                    </g>
                    <defs>
                      <clipPath id="clip0_6171_16082">
                        <rect width="200" height="11" fill="white" transform="translate(0 0.870117)" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <p className="mb-5  text-left text-2xl font-mfont font-medium text-body-color dark:text-dark-6">
                  At Making Minds Technologies , we are not just developers; we are architects of digital experiences,
                  pioneers in the realm of web development, and your partners in turning ideas into reality.
                  Established with a passion for innovation and a commitment to delivering unparalleled digital
                  solutions, we stand at the forefront of the ever-evolving landscape of technology.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="overflow-hidden  lg:m-10 m-5   bg-white dark:bg-dark">
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center ">
            <div className="w-full px-4 ">
              <div className="mt-1">
                <span className="block mb-4 font-mfont text-xl font-semibold text-primary">
                  Our Story <svg width="88" height="12" viewBox="0 0 200 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6171_16082)">
                      <path d="M98.474 1.84204C121.094 1.50816 143.714 1.06994 166.344 0.882134C175.926 0.798664 185.506 1.16385 195.077 1.54989C196.469 1.60206 198.77 2.73934 198.952 3.69925C199.22 5.05564 198.331 7.14239 197.207 8.14403C194.209 10.8151 190.346 11.5246 186.331 11.5454C171.633 11.6393 156.935 11.8897 142.237 11.8689C104.812 11.8376 67.3865 11.7019 29.9615 11.5767C22.7142 11.5559 15.4775 11.368 8.23016 11.295C4.63324 11.2637 1.58232 9.93865 -0.355309 7.0798C-1.12608 5.95295 -1.1796 3.87662 -0.65505 2.58283C-0.301783 1.70639 1.62513 0.944734 2.85621 0.944734C34.7253 0.861264 66.5943 0.87169 98.474 0.87169C98.474 1.1847 98.474 1.50815 98.474 1.82117V1.84204Z" fill="#00CEB3" />
                    </g>
                    <defs>
                      <clipPath id="clip0_6171_16082">
                        <rect width="200" height="11" fill="white" transform="translate(0 0.870117)" />
                      </clipPath>
                    </defs>
                  </svg>

                </span>
                <p className="mb-5  text-left text-2xl font-mfont font-medium text-body-color dark:text-dark-6">
                  Born out of a shared vision to revolutionize the digital space, Making Minds Technologies was
                  founded by a group of seasoned professionals with collective experience in the industry.
                  From the outset, we set out to create a company that embodies creativity, technical
                  expertise, and client-centric values
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <div className="container m-auto px-6 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between relative w-100 h-auto md:h-64 bg-mcolor rounded-lg p-8">
          <div className="w-8/12 text-2xl">
            <span className="flex text-5xl font-mfont text-white">Join the Making Minds Technologies network.</span>
          </div>
          <div className="relative shadow-md font-medium my-5 py-2 px-4 text-black cursor-pointer bg-white hover:bg-gray-300 rounded text-lg text-center w-48">
            <span className="absolute  right-0 top-0 animate-ping inline-flex rounded-full h-3 w-3 bg-blue-700">
            </span>
            <a href="https://www.linkedin.com/company/making-minds-technologies-private-limited/"
              target='_blank'
              rel="noreferrer"
            > Join to network</a>
          </div>
        </div>
      </div>

      <NewsLetter />
    </div>
  )
}

export default About